import TypeError from '.TypeError';
import WeakMap from '.WeakMap';
import Proxy from '.Proxy';
import Object_assign from '.Object.assign';
import Object_create from '.Object.create';
import Object_is from '.Object.is';
import Object_defineProperty from '.Object.defineProperty';
import Object_getOwnPropertyDescriptor from '.Object.getOwnPropertyDescriptor';
import Object_defineProperties from '.Object.defineProperties';
import Object_fromEntries from '.Object.fromEntries';
import Object_freeze from '.Object.freeze';
import hasOwnProperty from '.Object.prototype.hasOwnProperty';
import Reflect_apply from '.Reflect.apply';
import Reflect_construct from '.Reflect.construct';
import Reflect_defineProperty from '.Reflect.defineProperty';
import Reflect_deleteProperty from '.Reflect.deleteProperty';
import Reflect_ownKeys from '.Reflect.ownKeys';
import undefined from '.undefined';
import NULL from '.null.prototype';

import version from './version?text';
export { version };

                           
                                                     
                     
const Keeper =     ()      => [];

const hasOwnProperty_call = /*#__PURE__*/hasOwnProperty.call.bind(hasOwnProperty);

const newWeakMap = () => {
	const weakMap = new WeakMap;
	weakMap.has = weakMap.has;
	weakMap.get = weakMap.get;
	weakMap.set = weakMap.set;
	return weakMap;
};
const target2keeper = /*#__PURE__*/newWeakMap()     
	                                                                      
	                                                                         
 ;
const proxy2target = /*#__PURE__*/newWeakMap()     
	                             
	                                                 
	                                                   
 ;
const target2proxy = /*#__PURE__*/newWeakMap()     
	                                                  
	                                                   
 ;

const ExternalDescriptor =                                (source   )    => {
	const target = Object_create(NULL)     ;
	if ( hasOwnProperty_call(source, 'enumerable') ) { target.enumerable = source.enumerable; }
	if ( hasOwnProperty_call(source, 'configurable') ) { target.configurable = source.configurable; }
	if ( hasOwnProperty_call(source, 'value') ) { target.value = source.value; }
	if ( hasOwnProperty_call(source, 'writable') ) { target.writable = source.writable; }
	if ( hasOwnProperty_call(source, 'get') ) { target.get = source.get; }
	if ( hasOwnProperty_call(source, 'set') ) { target.set = source.set; }
	return target;
};

const handlers                       = /*#__PURE__*/Object_assign(Object_create(NULL), {
	defineProperty:                 (target                   , key   , descriptor                    )          => {
		if ( hasOwnProperty_call(target, key) ) {
			return Reflect_defineProperty(target, key, Object_assign(Object_create(NULL), descriptor));
		}
		if ( Reflect_defineProperty(target, key, Object_assign(Object_create(NULL), descriptor)) ) {
			const keeper = target2keeper.get(target) ;
			keeper[keeper.length] = key;
			return true;
		}
		return false;
	},
	deleteProperty:                 (target                   , key   )          => {
		if ( Reflect_deleteProperty(target, key) ) {
			const keeper = target2keeper.get(target) ;
			const index = keeper.indexOf(key);
			index<0 || --keeper.copyWithin(index, index + 1).length;
			return true;
		}
		return false;
	},
	ownKeys:                    (target   ) => target2keeper.get(target)                         ,
	construct:                                     (target                         , args   , newTarget     )    => orderify(Reflect_construct(target, args, newTarget)),
	apply:                                        (target                              , thisArg   , args   )    => orderify(Reflect_apply(target, thisArg, args)),
});

const newProxy =                                              (target   , keeper           )    => {
	target2keeper.set(target, keeper);
	const proxy = new Proxy   (target, handlers);
	proxy2target.set(proxy, target);
	return proxy;
};

export const isOrdered = (object        )          => proxy2target.has(object);
export const is = (object1        , object2        )          => Object_is(
	proxy2target.get(object1) || object1,
	proxy2target.get(object2) || object2,
);

export const orderify =                    (object   )    => {
	if ( proxy2target.has(object) ) { return object; }
	let proxy = target2proxy.get(object)                 ;
	if ( proxy ) { return proxy; }
	proxy = newProxy(object, Object_assign(Keeper          (), Reflect_ownKeys(object)));
	target2proxy.set(object, proxy);
	return proxy;
};

                                                                                                       
export const { create } = {
	create                                                          (proto          , ...descriptorMaps      )                                                                  {
		const keeper = Keeper           ();
		if ( descriptorMaps.length ) {
			const descriptorMap     = Object_assign(newProxy(Object_create(NULL)      , keeper), ...descriptorMaps);
			const { length } = keeper;
			let index = 0;
			while ( index!==length ) {
				const key = keeper[index++] ;
				descriptorMap[key] = ExternalDescriptor(descriptorMap[key]);
			}
			return newProxy(Object_create(proto, descriptorMap)       , keeper       );
		}
		return newProxy(Object_create(proto)       , keeper       );
	}
};
export const { defineProperties } = {
	defineProperties                                                     (object   , descriptorMap    , ...descriptorMaps      )                                                                     {
		const keeper = Keeper           ();
		descriptorMap = Object_assign(newProxy(Object_create(NULL)      , keeper), descriptorMap, ...descriptorMaps);
		const { length } = keeper;
		let index = 0;
		while ( index!==length ) {
			const key = keeper[index++] ;
			descriptorMap[key] = ExternalDescriptor(descriptorMap[key]);
		}
		return Object_defineProperties(orderify(object), descriptorMap);
	}
};
export const getOwnPropertyDescriptors =                    (object   )                                => {
	const descriptorMap = Object_create(NULL)                                 ;
	const keeper = Object_assign(Keeper          (), Reflect_ownKeys(object));
	const { length } = keeper;
	let index = 0;
	while ( index!==length ) {
		const key = keeper[index++] ;
		descriptorMap[key] = Object_assign(Object_create(NULL), Object_getOwnPropertyDescriptor(object, key) );
	}
	return newProxy(descriptorMap, keeper);
};

export const Null = /*#__PURE__*/function () {
	function throwConstructing ()        { throw TypeError(`Super constructor Null cannot be invoked with 'new'`); }
	function throwApplying ()        { throw TypeError(`Super constructor Null cannot be invoked without 'new'`); }
	const Nullify = (constructor                             ) => {
		delete constructor.prototype.constructor;
		Object_freeze(constructor.prototype);
		return constructor;
	};
	function Null (           constructor                              ) {
		return new.target
			? new.target===Null
				? /*#__PURE__*/throwConstructing()
				: /*#__PURE__*/newProxy(this, Keeper     ())
			: typeof constructor==='function'
				? /*#__PURE__*/Nullify(constructor)
				: /*#__PURE__*/throwApplying();
	}
	//@ts-ignore
	Null.prototype = null;
	Object_defineProperty(Null, 'name', Object_assign(Object_create(NULL), { value: '', configurable: false }));
	//delete Null.length;
	Object_freeze(Null);
	return Null;
}()                                           ;
                                                                   

const DEFAULT = /*#__PURE__*/Object_assign(class extends null { writable () {} enumerable () {} configurable () {} }.prototype                             , {
	constructor: undefined,
	writable: true,
	enumerable: true,
	configurable: true,
});
export const fromEntries =                                                  (entries                                            , proto           )                      => {
	const target = Object_fromEntries(entries);
	const keeper            = Object_assign(Keeper   (), Reflect_ownKeys(target));
	if ( proto===undefined ) { return newProxy(target                       , keeper); }
	if ( proto===null ) { return newProxy(Object_assign(Object_create(proto), target)                       , keeper); }
	const descriptorMap = Object_create(NULL)                                            ;
	const { length } = keeper;
	let index = 0;
	while ( index!==length ) {
		const key    = keeper[index++] ;
		( descriptorMap[key] = Object_create(DEFAULT)                               ).value = target[key];
	}
	return newProxy(Object_create(proto, descriptorMap)                       , keeper);
};

import Default from '.default';
export default /*#__PURE__*/Default({
	version,
	isOrdered,
	is,
	orderify,
	create,
	defineProperties,
	Null,
	fromEntries,
	getOwnPropertyDescriptors,
});
